<template>
  <div>
    <appBuilding :is-new="false" />
  </div>
</template>

<script>
import appBuilding from "@/components/catalogs/buildings/Building";

export default {
  components: {
    appBuilding,
  },
};
</script>
